export const containerStyle = {
  width: '100%',
  height: '100%'
};
